// extracted by mini-css-extract-plugin
export default {"home":"Home_home__PqZOu","logout":"Home_logout__xu49i"};